import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import './PowerSolutionPageBanner.css'
import './ResponsivePowerSolutionPageBanner.css'
const host = process.env.REACT_APP_API_SERVER;
const PowerSolutionPageBanner = (categoryData) => {

    const data = categoryData?.categoryData


    return (
        <>
            {/* <section className='power-solution-page-banner-section'>
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 text-start">
                            <div className="business-heading text-start">
                                <img src="/images/power-solution/heading-bg.png" alt="" className='img-fluid' />
                                <div className='business-banner-heading'>
                                    <h1>Power Solution</h1>
                                    <h5>"Efficient power solutions for a sustainable and brighter future ahead."</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className='power-solution-page-banner-section'>
                <div className=" align-items-center">
                    <div className="text-start">
                        <div className="banner-top-img-bg-rel">
                            <img src={data?.banner ? `${host}/${data?.banner}` : "/images/power-solution/banner-bg-1.jpg"} alt="" className='img-fluid' />
                            {/* Hide h1 tags */}
                            {/* <div className="banner-top-content-absolute business-heading text-start">
                                <img src="/images/power-solution/heading-bg.png" alt="" className='img-fluid banner-img-tag' />
                                <div className='business-banner-heading'>
                                    <div className="container">
                                        <h1 className='d-xl-block  d-none'>{data?.name}</h1>
                                        <h5 className='d-xl-block  d-none'>{`"${data?.subtitle ? data?.subtitle : "Efficient power solutions for a sustainable and brighter future ahead."}"`}</h5>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            {/* <div className='container align-items-center text-center py-3'>
                <div className='business-banner-heading'>
                    <div className="container">
                        <h1 style={{ fontSize: "25px", fontWeight: "700" }} className='d-xl-none  d-block'>{data?.name}</h1>
                        <h5 style={{ fontSize: "16px", fontWeight: "700" }} className='d-xl-none dynamicdesc  d-block'>{`"${data?.subtitle ? data?.subtitle : "Efficient power solutions for a sustainable and brighter future ahead."}"`}</h5>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default PowerSolutionPageBanner